// extracted by mini-css-extract-plugin
export var about = "about-module--about--apyJm";
export var aboutCenter = "about-module--about-center--0jkBS";
export var aboutImg = "about-module--about-img--cQ0bv";
export var aboutInfo = "about-module--about-info--Pg5ip";
export var imgContainer = "about-module--img-container---BwYV";